window.addEventListener('DOMContentLoaded', function() {
	(function( $ ) {      
        
    	$(function() {
    		console.log('js loaded2');
    	});
      
      	$(function() {
 			var c = document.getElementsByClassName("box-3")[0].children[1].lastElementChild;
          	var li=document.createElement('li');
          	
            var a = document.createElement('a');
            var linkText = document.createTextNode("Cookie Settings");
            a.appendChild(linkText);
            a.title = "Cookie Settings";
            a.href = "#cookie-settings";
		 
            c.appendChild(li);
            li.appendChild(a);
        });
      
      
        $(function(){
          
        });
      
      
      
      
      
 	})(jq223);
});